import { Select, SelectProps } from 'antd';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useStudentsList } from '@/store';

type Props = {
  value?: string | string[];
  placeholder?: string;
  style?: SelectProps['style'];
  mode?: 'multiple' | 'tags';
  onChange?: (value: string | string[]) => void;
  allowClear?: boolean;
};

const DROPDOWN_WIDTH = 200;

export const StudentSearchSelector: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  style,
  mode,
  allowClear = false
}) => {
  const { t } = useTranslation();
  const { students, setSearch } = useStudentsList();

  const onSearch = debounce((search: string) => setSearch(search), 500);

  return (
    <Select
      showSearch
      style={style}
      value={value}
      mode={mode}
      maxTagCount={mode === 'multiple' ? 'responsive' : undefined}
      allowClear={allowClear}
      onChange={onChange}
      placeholder={placeholder ?? t('SELECT_USER')}
      onSearch={onSearch}
      defaultActiveFirstOption={false}
      filterOption={false}
      options={students?.map(({ _id, name, lastName }) => ({
        label: `${name} ${lastName}`,
        value: _id
      }))}
      suffixIcon={<Icon i="CaretDown" />}
      styles={{ popup: { root: { width: DROPDOWN_WIDTH } } }}
    />
  );
};
